import qs from 'query-string'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ActionButtonVariant } from '../../../components/ActionButton/styled'
import { AdsSortingFiltersProps } from '../../../components/AdsSortingFilters'
import { AdsSortingFiltersVariant } from '../../../components/AdsSortingFilters/styled'
import { Icons } from '../../../components/Icon'
import { PublicationGuideSmallCardProps } from '../../../components/PublicationGuideSmallCard'
import Router from '../../../routes/Router'
import routes from '../../../routes/definitions'
import { ListDisplayType } from '../../../types/classified'
import { useAdsSortingFiltersFormProps } from '../../Classified/Forms/useAdsSortingFiltersFormProps'
import { ActionButtonTransformer } from '../../Transformers/LinkTransformer'
import { BlockProps } from '../props'

import { FormSearchAdsProps } from './props'
import * as SC from './styled'

const FormSearchAds: FC<BlockProps<FormSearchAdsProps>> = ({
  data,
  specialities,
  categories,
}) => {
  const { t } = useTranslation()

  const formProps = useAdsSortingFiltersFormProps({
    specialities: specialities ?? [],
    categories: categories ?? [],
    isOpen: true,
    onSubmit: (values) => {
      Router.push(
        Router.getRouteUrl(routes.classifiedSearch) +
          '?' +
          qs.stringify(
            {
              ...(values.offerType && {
                offerType: values.offerType,
              }),
              ...(values.term && {
                terms: values.term,
              }),
              ...(values.localization && {
                lat: values.lat,
              }),
              ...(values.localization && {
                lng: values.lng,
              }),
              ...(values.radius && {
                radius: values.radius,
              }),
              ...(values.localization && {
                localization: values.localization,
              }),
              ...(values.specialities && {
                specialities: values.specialities,
              }),
              ...(values.startDate && {
                startDate: values.startDate,
              }),
              ...(values.endDate && {
                endDate: values.endDate,
              }),
              ...(values.days && {
                days: values.days,
              }),
              displayType: ListDisplayType.Card,
            },
            { arrayFormat: 'comma' }
          )
      )
    },
    submitButtonVariant: 'primary',
  })

  const SortingFiltersAdsProps: AdsSortingFiltersProps = useMemo(
    () => ({
      title: data?.title ?? '',
      searchForm: formProps,
      isOpen: true,
      variant: AdsSortingFiltersVariant.primary,
    }),
    [data, formProps]
  )

  const smallCardProps: PublicationGuideSmallCardProps = useMemo(
    () => ({
      title: t('smallCardGuideTitle'),
      text: t('smallCardGuideDescription'),
      button: {
        ...ActionButtonTransformer(data.link),
        variant: ActionButtonVariant.quaternary,
      },
    }),
    [t, data]
  )

  return (
    <SC.Section>
      <SC.SortingFiltersAds {...SortingFiltersAdsProps} />
      <SC.SmallCardPublicationGuide {...smallCardProps} />
      <SC.CrossesIcon icon={Icons.crossesSecondary} width={135} height={106} />
    </SC.Section>
  )
}
export default FormSearchAds
